

import { getConnectorClient, getClient } from '@wagmi/core';
import {
  BrowserProvider,
  FallbackProvider,
  JsonRpcProvider,
  JsonRpcSigner,
} from 'ethers';
import { currentChain, wagmiConfig } from '../connectors/wagmiConfig.js';

export function clientToSigner(client) {
  const { account, chain, transport } = client;
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };
  const provider = new BrowserProvider(transport, network);
  const signer = new JsonRpcSigner(provider, account.address);

  return signer;
}

export async function getEthersSigner(chainId = currentChain.id) {
  const client = await getConnectorClient(wagmiConfig, { chainId: +chainId });

  return clientToSigner(client);
}

export function clientToProvider(client) {
  const { chain, transport } = client;
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };

  if (transport.type === 'fallback') {
    const providers = transport.transports.map(
      ({ value }) => new JsonRpcProvider(value?.url, network)
    );
    if (providers.length === 1) return providers[0];

    return new FallbackProvider(providers);
  }

  return new JsonRpcProvider(transport.url, network);
}

/** Action to convert a viem Client to an ethers.js Provider. */
export function getEthersProvider(chainId = currentChain.id) {
  const client = getClient(wagmiConfig, { chainId: +chainId });
  if (!client) return;

  return clientToProvider(client);
}

// reference: https://wagmi.sh/core/guides/ethers
